import React, { useState } from 'react'
import { Button, Backdrop, CircularProgress } from '@material-ui/core'
import { Container, Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import Mantenedores from './mantenedores'


const CierreConductores = () => {
    const [state, setState] = useState({ path: 'cierreConductores', key: 1, titulo: 'Cierre de Conductores', tipo: '', tabs: [] })
    const { user: currentUser } = useSelector(state => state.auth)
    // console.log(currentUser)
    const [loading, setLoading] = useState(false)

    const menuContent = [
        {
            group: 'Cierre de Conductores',
            user: ['eduardo@spread.cl'],
            permission: [],
            color: '#000',
            bgColor: '#00CC00',
            items: [
                {
                    title: 'Cierre de Conductores',
                    path: 'cierre',
                    tipo: 'cierre'
                }
            ]
        },
        {
            group: 'Conductores',
            user: ['eduardo@spread.cl', 'emilio.contreras@spread.cl', 'heiner.zuniga@spread.cl', 'planner@spread.cl'],
            permission: [],
            color: '#000',
            bgColor: '#1CD816',
            items: [
                {
                    button: 'Directorio',
                    title: 'Directorio de Conductores',
                    path: 'directorio',
                    tipo: 'conductores'
                },
                // {
                //     title: 'Agregar Conductor',
                //     path: 'agregarConductor',
                //     tipo: 'conductores'
                // },
            ]
        },
        {
            group: 'Bonos',
            user: ['eduardo@spread.cl', 'camila.pino@spread.cl'],
            permission: [],
            color: '#FFF',
            bgColor: 'rgb(0, 155, 120)',
            items: [
                {
                    title: 'Bonos & Descuentos',
                    path: 'bonosDescuentos',
                    tipo: 'bonos'
                },
            ]
        }
    ]

    return (
        <Container fluid className='pt-4 w-100'>
            <Backdrop
                sx={{ color: '#fff' }}
                style={{ zIndex: 999 }}
                open={loading}
            >
                <CircularProgress />
            </Backdrop>
            {/* main data inside the next Row */}
            <Row
                className='gx-0'
                style={{ height: 'calc(100vh - 50px' }}
            >
                <Col
                    xs={2}
                    className='text-center align-self-center spread-font'
                    style={{
                        padding: "10px"
                    }}
                >
                    <>
                        {
                            menuContent.map((group, index) => {
                                if (group.user.length === 0) {
                                    return (
                                        <div key={index}>
                                            <hr />
                                            <h6>{group.group}</h6>
                                            {
                                                group.items.map((item, index) => {
                                                    return (
                                                        <Button
                                                            key={index}
                                                            // color="primary"
                                                            variant="contained"
                                                            style={{
                                                                backgroundColor: group.bgColor,
                                                                color: group.color,
                                                                marginBottom: 5,
                                                                width: '100%'
                                                            }}
                                                            onClick={() => {
                                                                setState({ Path: item.path, key: state.key + 1, titulo: item.title, tipo: item.tipo })
                                                            }}
                                                        >
                                                            {item.title}
                                                        </Button>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                } else {
                                    if (group.user.includes(currentUser.email)) {
                                        return (
                                            <div key={index}>
                                                <hr />
                                                <h6>{group.group}</h6>
                                                {
                                                    group.items.map((item, index) => {
                                                        return (
                                                            <Button
                                                                key={index}
                                                                // color="primary"
                                                                variant="contained"
                                                                style={{
                                                                    backgroundColor: group.bgColor,
                                                                    color: group.color,
                                                                    marginBottom: 5,
                                                                    width: '100%'
                                                                }}
                                                                onClick={() => {
                                                                    setState({ Path: item.path, key: state.key + 1, titulo: item.title, tipo: item.tipo })
                                                                }}
                                                            >
                                                                {item.title}
                                                            </Button>
                                                        )
                                                    })
                                                }
                                            </div>
                                        )
                                    }
                                }
                            })
                        }
                    </>
                </Col>
                <Col
                    xs={10}
                    // className='text-center'
                    style={{
                        padding: "10px",
                        maxHeight: 'calc(100vh - 150px)',
                        // overflowY: 'auto'
                    }}
                >
                    <div className='text-center
                            align-self-center
                            justify-content-md-center'
                    >
                        <h1>{state.titulo}</h1>
                    </div>
                    {
                        state.tipo === ''
                            ? ''
                            : <Mantenedores path={state.Path} title={state.titulo} loading={loading} setLoading={setLoading} />
                    }
                </Col>
                {/* <Col xs={2}></Col> */}
            </Row>
        </Container>
    )
}

export default CierreConductores
